export default __webpack_public_path__ + "static/media/section4(1).725cd98d.png";